import { useState, useCallback } from 'react';
import { conductResearch } from '../services/research';
import { incrementRequestCount, saveResearch } from '../services/supabase';
import { useAuth } from '../context/AuthContext';

export function useResearch() {
  const { user, refreshProfile } = useAuth();
  const [research, setResearch] = useState(null);
  const [progress, setProgress] = useState({
    phase: 'idle',
    processed: 0,
    total: 0,
    message: ''
  });
  const [error, setError] = useState(null);

  const startResearch = useCallback(async (prompt) => {
    if (!user) {
      setError('Please log in to start research');
      return;
    }

    setError(null);
    setResearch(null);
    setProgress({ phase: 'idle', processed: 0, total: 0, message: '' });

    try {
      // Increment request count before starting
      await incrementRequestCount(user.id);
      await refreshProfile();

      // Conduct research with progress updates
      const result = await conductResearch(prompt, setProgress);

      // Save research to database
      await saveResearch(user.id, result);

      setResearch(result);
      return result;
    } catch (err) {
      setError(err.message);
      setProgress({ phase: 'error', processed: 0, total: 0, message: err.message });
      throw err;
    }
  }, [user, refreshProfile]);

  const reset = useCallback(() => {
    setResearch(null);
    setProgress({ phase: 'idle', processed: 0, total: 0, message: '' });
    setError(null);
  }, []);

  return {
    research,
    progress,
    error,
    startResearch,
    reset,
    isLoading: progress.phase !== 'idle' && progress.phase !== 'completed' && progress.phase !== 'error'
  };
}
